export default __webpack_public_path__ + "static/B0186-3810d5d262d0ed496e90a27a78d45eb4.png";